import JobFooter from '../../components/jobFooter';
import JobHeader from '../../components/jobHeader';
import JobHero from '../../components/jobHero';
import React, { Component } from 'react';

import { ActionCreators } from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RouteWithSubRoutes } from '../../components/subrouter';
import { withRouter} from 'react-router-dom';

import '../../styles/job-container.css';
import JobEmployerBranding from '../../components/JobEmployerBranding';
import JobIntro from '../../components/JobIntro';


class JobContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }
  
    render() {
        return (
            <section className="job-container">
                <JobHeader />
                <JobHero />
                <JobIntro />
                <div className="job-content">
                    {this.props.routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />)}
                </div> 
                {/* <JobEmployerBranding /><br /> */}
                <JobFooter />               
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobContainer));



// WEBPACK FOOTER //
// ./src/pages/unauth/jobContainer.js